import { request } from '../request';

const palpationApi = {
  /**
   * 查询手诊结果
   */
  getPalpationResult(palpationSheetId: number) {
    return request<GetPalpationResult>({
      path: '/pad/palpation/v1/result',
      query: { palpationSheetId },
    });
  },
  /**
   * 确认手诊结果、截图
   */
  savePalpation(params: FinishPalpationParams) {
    return request<string>({
      method: 'POST',
      path: '/pad/palpation/v1/save',
      data: params,
    });
  },
};

export default palpationApi;
